import cl from 'classnames';

import { BackgroundMode } from '../useModelViewerBackground';

const base =
  'py-2 pl-2 pr-2 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-6 focus:ring-base hover:text-gray-950 dark:hover:text-white focus:ring-offset-0';

function useModelViewerToolbarButtonClass(backgroundMode: BackgroundMode) {
  const hasBackground = backgroundMode !== 'default';

  return function getButtonClass(isActive = false): string {
    return cl(base, {
      'hover:bg-gray-200 dark:hover:bg-gray-700': !isActive && !hasBackground,
      'bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700':
        !isActive && hasBackground,
      'bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-500':
        isActive
    });
  };
}

export default useModelViewerToolbarButtonClass;
